import React from "react";
import Drawer from "./Drawer";
import Comments from "./Comments";
import CommentForm from "./CommentForm";
import {RESTComment} from "../services/types";
import "./CommentsDrawer.css";

interface CommentsDrawerProps {
    isOpen: boolean;
    onClose: () => void;
    comments: RESTComment[];
    postId: number;
    onCommentCreated: () => void;
    onCommentDeleted?: () => void;
}

const CommentsDrawer: React.FC<CommentsDrawerProps> = ({
    isOpen,
    onClose,
    comments,
    postId,
    onCommentCreated,
    onCommentDeleted
}) => {
    return (
        <Drawer
            isOpen={isOpen}
            onClose={onClose}
            title="Commentaires"
        >
            <div className="CommentsDrawer-comments">
                <Comments comments={comments} onCommentDeleted={onCommentDeleted} />
            </div>
            <div className="CommentsDrawer-form">
                <CommentForm postId={postId} onCommentCreated={onCommentCreated}/>
            </div>
        </Drawer>
    );
};

export default CommentsDrawer;
